import React from "react";

export default class PreviewNodeView extends React.Component {
    /**
     * Node view for diagram preview; no mouse events
     * @module PreviewNodeView
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
    }

    /**
     * Render note node
     * @returns {XML}
     */
    renderNote() {
        // Text overflow
        var desc = this.props.node.getConfig("note") ? this.props.node.getConfig("note") : "";
        if (desc.length > 150) {
            desc = desc.substring(0, 150) + "…";
        }
        const lines = desc.split(/\r?\n/g);
        var displayLines = [];
        for (var i = 0; i < lines.length; i++) {
            displayLines.push(lines[i]);
            displayLines.push(<br key={i}/>);
        }
        displayLines.pop();

        return (
            <div className={"basic-node preview note"}>
                <div className="title">
                    <div className="name">
                        <p>{displayLines}</p>
                    </div>
                </div>
            </div>
        );
    }

    /**
     * Render intent node
     * @returns {XML}
     */
    renderIntent() {
        return (
            <div className={"basic-node intent grey"}>
                <div className="title">
                    <div className="name">
                        <div className="icon">
                            <i className={"fe icon-" + this.props.node.props.iconClass}/>
                        </div>
                        {this.props.node.name}
                    </div>
                </div>
            </div>
        );
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const hasError = this.props.node.hasError();
        const colorClass = this.props.node.props.colorClass ? " " + this.props.node.props.colorClass : "";
        if (this.props.node.props.colorClass === "note") {
            return this.renderNote();
        }
        if (this.props.node.props.colorClass === "intent") {
            return this.renderIntent();
        }
        return (
            <div className={"basic-node preview" + colorClass + (hasError ? " error" : "")}>
                <div className={
                    "title large"
                    + (hasError ? " error" : "")
                }>
                    <div className="icon">
                        {!hasError && <i className={"fe icon-" + this.props.node.props.iconClass}/>}
                        {hasError && <i className={"fe icon-alert-triangle"}/>}
                    </div>
                    <div className="name">{this.props.node.name}</div>
                </div>
            </div>
        );
    }
}
